import { css } from 'emotion';

import { colors } from '../styles';

export const headerBackground = (stickyHeader?: boolean) => css`
  background-color: ${colors.white};

  ${
    stickyHeader &&
    `
    position: sticky;
    top: 0;
    z-index: 1000;
  `
  };
`;

export const header = css`
  background-color: ${colors.custom.lightestGray50};
  padding: 20px;
`;

export const headerTitleDivider = css`
  hr {
    margin: 10px 0 20px;
  }
`;

export const headerTitle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const divider = css``;

export const body = css`
  padding: 20px;
  flex-grow: 1;
`;
